import { palette, shades } from "lib/miolo";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import { orderBy } from "lodash";
import tinycolor from "tinycolor2";

interface IIntangibleAssetsListProps {
  intangibleAssets: IBrazilianCompanyIssuerTopLevelFragment["intangibleAssets"];
}

export default function IntangibleAssetsList({ intangibleAssets }: IIntangibleAssetsListProps) {
  return (
    <div
      css={{
        padding: 8,
        overflow: "hidden",
        backgroundColor: palette.white,
        borderRadius: 4,
      }}
    >
      <table
        css={{
          minWidth: "100%",
          fontSize: 14,
          fontFamily: "museo-sans-condensed",
          lineHeight: 1.33,
          letterSpacing: 0.6,
          textAlign: "left",
          textIndent: 0,
          borderColor: "inherit",
          borderCollapse: "collapse",
          "& > thead": {
            backgroundColor: palette.white,
          },
          "& th": {
            padding: "12px 16px",
            color: shades.greys.variants[2],
            fontWeight: 600,
            textTransform: "uppercase",
          },
          "& tr > td": {
            padding: "12px 16px",
          },
          "& > tbody": {
            "& tr": {
              borderColor: palette.fiord,
              borderTopWidth: 1,
              "&:hover": {
                backgroundColor: tinycolor(palette.catskillWhite).lighten(2).toHexString(),
                "& td:first-of-type": {
                  borderTopLeftRadius: 6,
                  borderBottomLeftRadius: 6,
                },
                "& td:last-of-type": {
                  borderTopRightRadius: 6,
                  borderBottomRightRadius: 6,
                },
              },
            },
          },
          "& tbody > tr": {
            borderTop: `solid 1px ${tinycolor(palette.mystic).lighten(3).toHexString()}`,
            borderBottom: "none",
            "&:hover, &:hover + tr": {
              borderTop: "solid 1px transparent",
            },
          },
        }}
      >
        <thead>
          <tr>
            <th>Descrição do Ativo</th>
            <th>Tipo</th>
          </tr>
        </thead>

        <tbody>
          {orderBy(intangibleAssets, ["type", "description"], ["asc", "asc"]).map((node, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={`${node.description}/${index}`}>
                <td>
                  <div>
                    <span
                      css={{
                        fontSize: 16,
                        fontWeight: 500,
                        color: shades.greys.variants[2],
                      }}
                    >
                      {node.description}
                    </span>
                  </div>

                  <div>
                    <span css={{ fontSize: 14, color: shades.greys.variants[3], letterSpacing: 1 }}>
                      Duração: {node.term}
                    </span>
                  </div>
                </td>

                <td>{node.type}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
